import { getConsentForGV } from "@otto-ec/eprivacy-cmp";
import { storage } from "@otto-ec/global-resources/storage";

export async function cookieConsentGiven() {
    const [ottot, otton] = await Promise.all([getConsentForGV("OTTOT"), getConsentForGV("OTTON")]);
    return ottot || otton || false;
}

export async function getStorage() {
    const consentGiven = await cookieConsentGiven();
    const storageInstance = storage(() => {
        if (consentGiven) {
            return window.localStorage;
        } else {
            return window.sessionStorage;
        }
    });
    return { instance: storageInstance, type: consentGiven ? "localStorage" : "sessionStorage" };
}
